<div class="lightGallery-captions bg-white text-left primary-font">
    <div class="flex justify-between w-full">
        <div class="w-3/4">
            <h5 class="font-bold text-slate-900 overflow-hidden truncate" [title]="data.attachment_name">
                {{data.attachment_name}}</h5>
            <p class="text-base text-gray-500 truncate">{{getAttachmentType(data.url)}} File</p>
        </div>
        <div class="flex items-center">
            <a class="no-underline px-2 py-1 rounded-full hover:bg-gray-200 mr-2" id="download-attachment"
                title="{{'text.download' | translate}}">
                <i class="ti ti-download text-2xl cursor-pointer"></i>
            </a>
            <a id="copy-link" class="no-underline px-2 py-1 rounded-full hover:bg-gray-200"
                title="{{'copy_link.text' | translate}}">
                <i class="ti ti-link text-2xl"></i>
            </a>
        </div>
    </div>
    <hr class="my-2">
    <p class="text-lg font-bold">{{'text.specification' | translate}}</p>
    <div class="pr-3 py-1.5">
        <p *ngIf="data?.size">
            <span class="text-lg">{{'text.size' | translate}}</span> : <span
                class="text-lg text-gray-500">{{_utilityService.getFileSize(data.size * 1000)}}</span>
        </p>
        <p *ngIf="data?.created_by_first_name">
            <span class="text-lg">{{'text.uploaded_by' | translate}}</span> : <span class="text-lg text-gray-500">{{data.created_by_first_name}}
                {{data.created_by_last_name}}</span>
        </p>
        <p *ngIf="data?.created_at">
            <span class="text-lg">{{'text.uploaded_at' | translate}}</span> : <span class="text-lg text-gray-500">{{data.created_at |
                datetime:dateTimeFormat}}</span>
        </p>
    </div>
    <div class="mt-3" *ngIf="mapOptions?.coords?.length">
        <div class="flex justify-between mb-1">
            <p class="text-lg font-bold mt-0">{{'text.location' | translate}}</p>
            <a class="text-lg text-indigo-600" target="_blank"
                [href]="_locationPreviewService.displayOnGoogleMap(mapOptions)">{{'text.view_on_map' | translate}}</a>
        </div>
        <location-preview [options]="mapOptions"></location-preview>
    </div>
</div>